// contentEditPage.tsx
// ─────────────────────────────────────────────────────────────────────────────
// Router wrapper — reads :contentType from the URL and delegates to the
// matching page component.
//
// Adding a new content type:
//   1. Create ContentSectionEditPage{Type}.tsx
//   2. Add a case below
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import { useParams } from 'react-router-dom';
import ContentSectionEditPageProduct from '../../product-page/ts/contentSectionEditPageProduct';
import ContentSectionEditPage        from './contentSectionEditPage';
import ContentSectionEditPageCareer from '../../career-page/ts/contentSectionEditPageCareer';
import ContentSectionEditPageContact from '../../contact-page/ts/contentSectionEditPageContact';
import ContentSectionEditPageSale from '../../sale-contact-page/ts/contentSectionEditPageSale';
import ContentSectionEditPageBusiness from '../../business-contact-page/ts/contentSectionEditPageBusiness';
import ContentSectionEditPageJobDetail from '../../job-detail-page/ts/contentSectionEditPageJobDetail';
import ContentSectionEditPageCompany from '../../company-page/ts/contentSectionEditPageCompany';
import ContentSectionEditPageNavigation from '../../navigation-page/ts/contentSectionEditPageNavigation';

const ContentEditPage: React.FC = () => {
  const { contentType } = useParams<{ contentType: string }>();

  switch (contentType) {
    case 'product':
      return <ContentSectionEditPageProduct />;
    case 'career':
      return <ContentSectionEditPageCareer />
    case 'contact':
      return <ContentSectionEditPageContact />
    case 'sale':
      return <ContentSectionEditPageSale />
    case 'business':
      return <ContentSectionEditPageBusiness/>
    case 'job-detail':
      return <ContentSectionEditPageJobDetail />
    case 'company':
      return <ContentSectionEditPageCompany />
    case 'navigation':
      return <ContentSectionEditPageNavigation />
    default:
      // All other content types fall through to the generic dynamic editor
      return <ContentSectionEditPage />;
  }
};

export default ContentEditPage;